function required(value,label,max=160){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function timestamp(value,label){
  const text=String(value??'').trim();
  if(!text||Number.isNaN(Date.parse(text)))throw new TypeError(label+' must be an ISO timestamp');
  return text;
}

function version(value){
  const number=Number(value);
  if(!Number.isInteger(number)||number<1)throw new TypeError('savedRecipeVersion must be a positive integer');
  return number;
}

export function recipeSaveId(userId,recipeId){
  return required(userId,'userId',128)+':'+required(recipeId,'recipeId',128);
}

export function createRecipeSave({
  id,
  userId,
  recipeId,
  savedRecipeVersion,
  savedAt=new Date().toISOString(),
  updatedAt=savedAt
}={}){
  const owner=required(userId,'userId',128);
  const recipe=required(recipeId,'recipeId',128);
  const saved=timestamp(savedAt,'savedAt');
  const updated=timestamp(updatedAt,'updatedAt');
  if(Date.parse(updated)<Date.parse(saved))throw new TypeError('updatedAt cannot be before savedAt');
  const expected=recipeSaveId(owner,recipe);
  if(id&&String(id)!==expected)throw new TypeError('Recipe save id must match owner and recipe');
  return Object.freeze({
    id:expected,
    userId:owner,
    recipeId:recipe,
    savedRecipeVersion:version(savedRecipeVersion),
    savedAt:saved,
    updatedAt:updated
  });
}

export function recipeSaveToRow(value){
  const save=createRecipeSave(value);
  return Object.freeze({
    user_id:save.userId,
    recipe_id:save.recipeId,
    saved_recipe_version:save.savedRecipeVersion,
    saved_at:save.savedAt,
    updated_at:save.updatedAt
  });
}

export function recipeSaveFromRow(row={}){
  return createRecipeSave({
    userId:row.user_id,
    recipeId:row.recipe_id,
    savedRecipeVersion:row.saved_recipe_version,
    savedAt:row.saved_at,
    updatedAt:row.updated_at
  });
}

export function recipeSaveSourceState(save,recipe){
  const value=createRecipeSave(save);
  const recipeVersion=Number(recipe?.version);
  if(!Number.isInteger(recipeVersion)||recipeVersion<1)throw new TypeError('Recipe version is required');
  return Object.freeze({
    recipeId:value.recipeId,
    savedRecipeVersion:value.savedRecipeVersion,
    currentRecipeVersion:recipeVersion,
    updateAvailable:recipeVersion>value.savedRecipeVersion,
    sourceChanged:recipeVersion!==value.savedRecipeVersion
  });
}
